<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
    }
</script>

<style>
@import './scss/_reset.scss';
@import './scss/_init.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue